import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Forgot password page — configurable, uses project Cognito User Pool.
 * Steps: request code → confirm new password.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthConfig } from '../config';
import { getCognitoUser } from '../services/cognito-auth';
import { Button, Input, PasswordRequirements, isPasswordValid } from './ui';
export function ForgotPasswordPage({ className }) {
    const navigate = useNavigate();
    const config = getAuthConfig();
    const { login: loginConfig } = config;
    const [step, setStep] = useState('request');
    const [username, setUsername] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [cognitoUser, setCognitoUser] = useState(null);
    const handleRequestCode = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        const user = getCognitoUser(username);
        setCognitoUser(user);
        user.forgotPassword({
            onSuccess: () => {
                setStep('confirm');
                setLoading(false);
            },
            onFailure: (err) => {
                setLoading(false);
                if (err.code === 'UserNotFoundException') {
                    setError('Utente non trovato');
                }
                else if (err.code === 'LimitExceededException') {
                    setError('Troppi tentativi. Riprova più tardi.');
                }
                else {
                    setError(err.message || 'Errore durante la richiesta');
                }
            },
        });
    };
    const handleConfirmPassword = async (e) => {
        e.preventDefault();
        setError('');
        if (newPassword !== confirmPassword) {
            setError('Le password non corrispondono');
            return;
        }
        if (!isPasswordValid(newPassword)) {
            setError('La password non rispetta tutti i requisiti');
            return;
        }
        setLoading(true);
        cognitoUser.confirmPassword(code, newPassword, {
            onSuccess: () => {
                setLoading(false);
                navigate('/login?reset=true');
            },
            onFailure: (err) => {
                setLoading(false);
                if (err.code === 'CodeMismatchException') {
                    setError('Codice non valido');
                }
                else if (err.code === 'InvalidPasswordException') {
                    setError('La password non rispetta i requisiti: minimo 8 caratteri, una maiuscola, una minuscola, un numero e un carattere speciale.');
                }
                else if (err.code === 'ExpiredCodeException') {
                    setError('Il codice è scaduto. Richiedi un nuovo codice.');
                }
                else {
                    setError(err.message || 'Errore durante il reset');
                }
            },
        });
    };
    return (_jsx("div", { className: `ipsoft-login-page ${className || ''}`, children: _jsxs("div", { className: "ipsoft-login-card", children: [_jsx("h1", { children: "Recupero Password" }), error && (_jsx("div", { className: "ipsoft-alert ipsoft-alert-error", role: "alert", children: error })), step === 'request' && (_jsxs("form", { onSubmit: handleRequestCode, "aria-label": "Richiesta codice di recupero", children: [_jsxs("p", { className: "ipsoft-text-muted", style: { marginBottom: '1rem' }, children: ["Inserisci il tuo ", loginConfig.labels.identifierPlaceholder.toLowerCase(), ". Riceverai un codice per reimpostare la password."] }), _jsx(Input, { label: loginConfig.labels.identifierPlaceholder, value: username, onChange: (e) => setUsername(e.target.value), required: true, autoFocus: true }), _jsx(Button, { type: "submit", loading: loading, fullWidth: true, style: { marginTop: '1rem' }, children: "Invia codice di recupero" }), _jsx("div", { style: { textAlign: 'center', marginTop: '1rem' }, children: _jsx("a", { href: "/login", className: "ipsoft-link", children: "Torna al login" }) })] })), step === 'confirm' && (_jsxs("form", { onSubmit: handleConfirmPassword, "aria-label": "Nuova password", children: [_jsx("p", { className: "ipsoft-text-muted", style: { marginBottom: '1rem' }, children: "Abbiamo inviato un codice di verifica alla tua email. Inseriscilo qui sotto insieme alla nuova password." }), _jsx(Input, { label: "Codice di verifica", value: code, onChange: (e) => setCode(e.target.value), required: true, autoFocus: true, inputMode: "numeric" }), _jsx(Input, { label: "Nuova password", type: "password", value: newPassword, onChange: (e) => setNewPassword(e.target.value), required: true, autoComplete: "new-password" }), _jsx(PasswordRequirements, { password: newPassword }), _jsx(Input, { label: "Conferma password", type: "password", value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value), required: true, autoComplete: "new-password" }), _jsx(Button, { type: "submit", loading: loading, fullWidth: true, style: { marginTop: '1rem' }, children: "Reimposta password" })] }))] }) }));
}
//# sourceMappingURL=ForgotPasswordPage.js.map